// extracted by mini-css-extract-plugin
module.exports = {"favorite":"Favorite_favorite__2Cc8y","link":"Favorite_link__B4JgS"};